// Theme details available
// http://www.material-ui.com/#/customization/themes

import colors from './colors'

const theme = {
  palette: {
    primary1Color: colors.primary,
    accent1Color: colors.accent
  },
  flatButton: {
    backgroundColor: colors.primary
  },
  p: {
    fontFamily: 'Roboto',
    fontSize: 13,
    lineHeight: 1.5
  },
  h2: {
    fontSize: 19,
    lineHeight: 2,
    fontWeight: 'bold',
    height: 25
  }
}

export { theme, colors }

export default theme



// WEBPACK FOOTER //
// ./src/config/theme/index.js